var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"mr-2",class:_vm.classIco,on:{"click":_vm.updateVal}})
}
var staticRenderFns = []

export { render, staticRenderFns }